import React from "react";
import configurationFile from "config/index";
const { identificationTypes } = configurationFile;

const AdditionalDetails = ({
	index,
	extraAdditionalDetails,
	handleAdditionalDetailsInput,
	loadingSubmit,
	requestLevel,
	removeAdditionalDetails,
	emailError,
}) => (
	<li key={`additionalDetails-${index}`} className="row col-12">
		{index > -1 && (
			<div className="col-12 d-flex align-items-center mb-1">
				<h5 className="font-weight-bold mb-0 mr-3">Estudiante {index + 2}</h5>
				<em
					className="fas fa-times-circle text-danger fa-lg pointer"
					onClick={() => removeAdditionalDetails(index)}
				/>
			</div>
		)}
		<div className="col-md-6 mb-3">
			<label className="font-weight-bold no-select">
				Número de identificación
			</label>
			<div className="input-group text-dark">
				<div className="input-group-prepend">
					<select
						id="identificationType"
						name="identificationType"
						className="form-control border-primary pointer"
						value={extraAdditionalDetails.identificationType}
						onChange={handleAdditionalDetailsInput(index)}
						required
					>
						<option></option>
						{identificationTypes.map((identificationType) => (
							<option className="pointer" key={identificationType}>
								{identificationType}
							</option>
						))}
					</select>
				</div>
				<input
					name="identification"
					className="form-control border-primary"
					type="number"
					disabled={loadingSubmit}
					value={extraAdditionalDetails.identification}
					onChange={handleAdditionalDetailsInput(index)}
					min="0"
					required
				/>
			</div>
		</div>
		<div className="col-12"></div>
		<div className="col-md-6 mb-3">
			<label className="font-weight-bold no-select">Nombre</label>
			<input
				name="name"
				className="form-control text-dark border-primary"
				type="text"
				disabled={loadingSubmit}
				value={extraAdditionalDetails.name}
				onChange={handleAdditionalDetailsInput(index)}
				placeholder="Nombre estudiante"
				minLength="2"
				required
			/>
		</div>
		<div className={`col-md-6 mb-3`}>
			<label className="font-weight-bold no-select">Apellidos</label>
			<input
				name="lastName"
				className="form-control text-dark border-primary"
				type="text"
				disabled={loadingSubmit}
				value={extraAdditionalDetails.lastName}
				onChange={handleAdditionalDetailsInput(index)}
				placeholder="Apellido estudiante"
				minLength="2"
				maxLength="100"
				required
			/>
		</div>
		<div className="col-12"></div>
		<div className="col-md-6 mb-3">
			<label className="font-weight-bold no-select">Correo electrónico</label>
			<input
				name="email"
				className={`form-control text-dark ${
					emailError ? "border-danger" : "border-primary"
				}`}
				type="email"
				disabled={loadingSubmit}
				value={extraAdditionalDetails.email}
				onChange={handleAdditionalDetailsInput(index)}
				minLength="2"
				maxLength="320"
				required
			/>
			<p className="small mb-1">
				* Ingresa el correo institucional o personal del estudiante. Recuerda
				que el correo no puede ser compartido con hermanos o acudiente.
			</p>
			{emailError && (
				<p className="text-danger text-small mb-1">
					** Por favor verifica el correo ingresado
				</p>
			)}
		</div>
		{requestLevel && (
			<div className="col-md-6 mb-3">
				<label className="font-weight-bold no-select">Curso</label>
				<input
					name="level"
					className="form-control text-dark border-primary"
					type="text"
					disabled={loadingSubmit}
					value={extraAdditionalDetails.level}
					onChange={handleAdditionalDetailsInput(index)}
					minLength="1"
					maxLength="320"
					required
				/>
				<p className="small mb-1">
					* Escribe la clase a la que pertence el estudiante,{" "}
					<strong>ejemplo: 803 ó 8C</strong>
				</p>
			</div>
		)}
	</li>
);

export default AdditionalDetails;
